<template>
  <div id="app">
    <navbarHeader/>
    <router-view/>
     <footers/>
  </div>

</template>
<script>
import navbarHeader from '@/components/global/navbarHeader.vue'
import footers from '@/components/global/footers.vue'
export default {
  name: 'home',
  components: {
    navbarHeader,
    footers
  }
}
</script>

<style lang="scss">
body{
  overflow-x: hidden;
  background: #2e2c2c !important;

}
</style>
